export default {
  AUTH_TOKEN: 'AUTH_TOKEN',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  USER_ID: 'USER_ID',
  DATA_AUTH: 'DATA_AUTH',
  USER_DATA: 'USER_DATA'
};
